import Informes from "../Informes.vue";

const routes = [
    ...route("/informes", Informes, {
        Auth: true,
    }),
];

function route(path, component = Default, meta = {}) {
    return [
        {
            path,
            component,
            meta,
        },
    ];
}

export default routes; 